import { EnvironmentProviders, importProvidersFrom } from '@angular/core';
import { MsalModule } from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../environments/environment';

function loggerCallback(logLevel: LogLevel, message: string): void {
  let method: (message?: any, ...optionalParams: any[]) => void;

  switch (logLevel) {
    case LogLevel.Error:
      method = console.error;
      break;
    case LogLevel.Warning:
      method = console.warn;
      break;
    case LogLevel.Info:
      method = console.log;
      break;
    case LogLevel.Verbose:
      method = console.debug;
      break;
    case LogLevel.Trace:
      method = console.trace;
      break;
  }

  method(message);
}

export function provideMsal(): EnvironmentProviders {
  return importProvidersFrom(
    MsalModule.forRoot(new PublicClientApplication({
      auth: environment.auth,
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage
      },
      system: {
        allowPlatformBroker: false,
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Error,
          piiLoggingEnabled: false
        }
      }
    }), {
      interactionType: InteractionType.Redirect,
      loginFailedRoute: environment.auth.redirectUri
    }, {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map([
        [`${environment.dl.url}*`, [environment.dl.scope]],
        [`${environment.fus.url}/*`, [environment.fus.scope]]
      ])
    }),
  );
}
